import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["date", "label"];
import React, { useCallback } from 'react';
import { cnBem } from '@carnica/utils';
import { motion } from 'framer-motion';
import { isSameMonth } from 'date-fns-new';
import { useDatePeriodList } from "../../hooks/useDatePeriodList";
import { Cell } from "../../Cell";
import styles from "./styles.pcss";
import { Grid } from "../../Grid";
var cnCalendarBlockMonth = cnBem('month-block', styles);
var isSamePeriod = function isSamePeriod(firstDate, secondDate) {
  if (!firstDate || !secondDate) {
    return false;
  }
  return isSameMonth(firstDate, secondDate);
};
export var CalendarBlockMonth = function CalendarBlockMonth(props) {
  var currentVisibleDate = props.currentVisibleDate,
    minDate = props.minDate,
    maxDate = props.maxDate,
    locale = props.locale,
    value = props.value,
    disableDates = props.disableDates,
    onChange = props.onChange;
  var handleChange = useCallback(function (date, e) {
    var sameMonth = date && value && isSameMonth(value, date);
    onChange === null || onChange === void 0 ? void 0 : onChange(sameMonth ? null : date, e);
  }, [onChange, value]);
  var months = useDatePeriodList({
    onChange: handleChange,
    type: 'month',
    locale: locale,
    currentVisibleDate: currentVisibleDate,
    disableDates: disableDates,
    maxDate: maxDate,
    minDate: minDate
  });
  return /*#__PURE__*/React.createElement(motion.div, null, /*#__PURE__*/React.createElement(Grid, {
    className: cnCalendarBlockMonth('list'),
    type: "month",
    "data-t-id": "CalendarBlocks-CalendarBlockMonth"
  }, months.map(function (_ref) {
    var date = _ref.date,
      label = _ref.label,
      params = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(Cell, _extends({
      "aria-label": label.toString(),
      className: cnCalendarBlockMonth('month'),
      key: date.toDateString(),
      rootProps: {
        className: cnCalendarBlockMonth('cell')
      },
      size: "m",
      view: isSamePeriod(value, date) ? 'selected' : 'default'
    }, params), label);
  })));
};